export default __webpack_public_path__ + "static/1_2-1493cea40dd5502e5ac7171542ab2962.png";